module.exports = __webpack_public_path__ + "img/index-title@2x.cba4ad80.png";